<template>
  <div id="user-data">
    <div class="flex flex-wrap-reverse items-center data-list-btn-container">
      <div class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary"  @click="ViewPerson($route.params.idperson)">
        <feather-icon icon="UserIcon" svgClasses="h-4 w-4" />
        <span class="ml-2 text-base text-primary">View Person</span>
      </div>
    </div>
    <div class="vx-row" id="page-user-view">
      <div class="vx-col lg:w-5/12 w-full">
        <vx-card :title="basic_data.person" class="mb-base">
          <table>
            <tr>
              <td class="font-semibold">Job Title</td>
              <td>{{ basic_data.jobtitle }}</td>
            </tr>
            <tr>
              <td class="font-semibold">
                Current
                Contract&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              </td>
              <td>
                {{ basic_data.name }}
              </td>
            </tr>
            <tr v-if="basic_data.isactive >= 0">
              <td class="font-semibold">Contract&nbsp;&nbsp;&nbsp;</td>
              <td style="color: #3ca787" v-if="basic_data.datestop">
                {{ basic_data.datestart }} → {{ basic_data.datestop }}
              </td>
              <td style="color: #3ca787" v-else>
                {{ basic_data.datestart }} → Permanent
              </td>
            </tr>
            <tr v-else>
              <td class="font-semibold">Contract&nbsp;&nbsp;&nbsp;</td>
              <td style="color: #ff0000" v-if="basic_data.datestop">
                {{ basic_data.datestart }} → {{ basic_data.datestop }}
              </td>
              <td style="color: #3ca787" v-else>
                {{ basic_data.datestart }} → Permanent
              </td>
            </tr>
          </table>
        </vx-card>
      </div>
      <div class="vx-col lg:w-3/12 w-full">
        <vx-card
          :title="getMonth(0)"
          class="mb-base"
          style="background-color: #3ca787; color: white"
        >
          <table>
            <tr>
              <td class="font-semibold">
                Worked&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              </td>
              <td
                v-if="
                  this.$store.state.dataListEmployee.summarypermonth0.worked
                "
              >
                <span
                  v-if="
                    this.$store.state.dataListEmployee.summarypermonth0.worked
                      .days &&
                    this.$store.state.dataListEmployee.summarypermonth0.worked
                      .hours
                  "
                  >{{
                    padLeadingZeros(
                      this.$store.state.dataListEmployee.summarypermonth0.worked
                        .days *
                        24 +
                        this.$store.state.dataListEmployee.summarypermonth0
                          .worked.hours,
                      2
                    )
                  }}:</span
                >
                <span
                  v-else-if="
                    this.$store.state.dataListEmployee.summarypermonth0.worked
                      .hours
                  "
                  >{{
                    padLeadingZeros(
                      this.$store.state.dataListEmployee.summarypermonth0.worked
                        .hours,
                      2
                    )
                  }}:</span
                >
                <span v-else>00:</span>
                <span
                  v-if="
                    this.$store.state.dataListEmployee.summarypermonth0.worked
                      .minutes
                  "
                  >{{
                    padLeadingZeros(
                      this.$store.state.dataListEmployee.summarypermonth0.worked
                        .minutes,
                      2
                    )
                  }}:</span
                >
                <span v-else>00:</span>
                <span
                  v-if="
                    this.$store.state.dataListEmployee.summarypermonth0.worked
                      .seconds
                  "
                  >{{
                    padLeadingZeros(
                      this.$store.state.dataListEmployee.summarypermonth0.worked
                        .seconds,
                      2
                    )
                  }}</span
                >
                <span v-else>00</span>
              </td>
              <td v-else>N/A</td>
            </tr>
            <tr>
              <td class="font-semibold">Working</td>
              <td>{{ workday_count(0) * 8 }} hours</td>
            </tr>
          </table>
        </vx-card>
      </div>
      <div class="vx-col lg:w-2/12 w-full">
        <vx-card :title="getMonth(-1)" class="mb-base">
          <table>
            <tr>
              <td class="font-semibold">
                Worked&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              </td>
              <td
                v-if="
                  this.$store.state.dataListEmployee.summarypermonth1.worked
                "
              >
                <span
                  v-if="
                    this.$store.state.dataListEmployee.summarypermonth1.worked
                      .days &&
                    this.$store.state.dataListEmployee.summarypermonth1.worked
                      .hours
                  "
                  >{{
                    padLeadingZeros(
                      this.$store.state.dataListEmployee.summarypermonth1.worked
                        .days *
                        24 +
                        this.$store.state.dataListEmployee.summarypermonth1
                          .worked.hours,
                      2
                    )
                  }}:</span
                >
                <span
                  v-else-if="
                    this.$store.state.dataListEmployee.summarypermonth1.worked
                      .hours
                  "
                  >{{
                    padLeadingZeros(
                      this.$store.state.dataListEmployee.summarypermonth1.worked
                        .hours,
                      2
                    )
                  }}:</span
                >
                <span v-else>00:</span>
                <span
                  v-if="
                    this.$store.state.dataListEmployee.summarypermonth1.worked
                      .minutes
                  "
                  >{{
                    padLeadingZeros(
                      this.$store.state.dataListEmployee.summarypermonth1.worked
                        .minutes,
                      2
                    )
                  }}:</span
                >
                <span v-else>00:</span>
                <span
                  v-if="
                    this.$store.state.dataListEmployee.summarypermonth1.worked
                      .seconds
                  "
                  >{{
                    padLeadingZeros(
                      this.$store.state.dataListEmployee.summarypermonth1.worked
                        .seconds,
                      2
                    )
                  }}</span
                >
                <span v-else>00</span>
              </td>
              <td v-else>N/A</td>
            </tr>
            <tr>
              <td class="font-semibold">
                Working&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              </td>
              <td>{{ workday_count(-1) * 8 }} hours</td>
            </tr>
          </table>
        </vx-card>
      </div>
      <div class="vx-col lg:w-2/12 w-full">
        <vx-card :title="getMonth(-2)" class="mb-base">
          <table>
            <tr>
              <td class="font-semibold">
                Worked&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              </td>
              <td
                v-if="
                  this.$store.state.dataListEmployee.summarypermonth2.worked
                "
              >
                <span
                  v-if="
                    this.$store.state.dataListEmployee.summarypermonth2.worked
                      .days &&
                    this.$store.state.dataListEmployee.summarypermonth2.worked
                      .hours
                  "
                  >{{
                    padLeadingZeros(
                      this.$store.state.dataListEmployee.summarypermonth2.worked
                        .days *
                        24 +
                        this.$store.state.dataListEmployee.summarypermonth2
                          .worked.hours,
                      2
                    )
                  }}:</span
                >
                <span
                  v-else-if="
                    this.$store.state.dataListEmployee.summarypermonth2.worked
                      .hours
                  "
                  >{{
                    padLeadingZeros(
                      this.$store.state.dataListEmployee.summarypermonth2.worked
                        .hours,
                      2
                    )
                  }}:</span
                >
                <span v-else>00:</span>
                <span
                  v-if="
                    this.$store.state.dataListEmployee.summarypermonth2.worked
                      .minutes
                  "
                  >{{
                    padLeadingZeros(
                      this.$store.state.dataListEmployee.summarypermonth2.worked
                        .minutes,
                      2
                    )
                  }}:</span
                >
                <span v-else>00:</span>
                <span
                  v-if="
                    this.$store.state.dataListEmployee.summarypermonth2.worked
                      .seconds
                  "
                  >{{
                    padLeadingZeros(
                      this.$store.state.dataListEmployee.summarypermonth2.worked
                        .seconds,
                      2
                    )
                  }}</span
                >
                <span v-else>00</span>
              </td>
              <td v-else>N/A</td>
            </tr>
            <tr>
              <td class="font-semibold">
                Working&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              </td>
              <td>{{ workday_count(-2) * 8 }} hours</td>
            </tr>
          </table>
        </vx-card>
      </div>
    </div>
    <vx-card>
      <div slot="no-body" class="tabs-container px-6 pt-6">
        <div class="tab-text">
          <template>
            <div id="user-edit-tab-info">
              <!-- Content Row -->
              <div class="vx-row"></div>
              <template>
                <div id="data-list-list-view" class="data-list-container">
                  <data-view-sidebar
                    :isSidebarActive="addNewDataSidebar"
                    @closeSidebar="toggleDataSidebar"
                    :data="sidebarData"
                  />

                  <vs-table ref="table" :data="attendances">
                    <div
                      slot="header"
                      class="
                        flex flex-wrap-reverse
                        items-center
                        flex-grow
                        justify-between
                      "
                    >
                      <div
                        class="
                          flex flex-wrap-reverse
                          items-center
                          data-list-btn-container
                        "
                      >
                        <!-- ACTION - DROPDOWN -->

                        <!-- ADD NEW -->
                        <div
                          class="
                            btn-add-new
                            p-3
                            mb-4
                            mr-4
                            rounded-lg
                            cursor-pointer
                            flex
                            items-center
                            justify-center
                            text-lg
                            font-medium
                            text-base text-primary
                            border border-solid border-primary
                          "
                          @click="addNewData"
                        >
                          <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
                          <span class="ml-2 text-base text-primary"
                            >Add Attendance</span
                          >
                        </div>
                      </div>
                    </div>

                    <template slot="thead">
                      <vs-th>#</vs-th>
                      <vs-th>Date Start</vs-th>
                      <vs-th>Date Stop</vs-th>
                      <vs-th>Hours</vs-th>
                      <vs-th>Comment</vs-th>
                      <vs-th>Photo in</vs-th>
                      <vs-th>Photo out</vs-th>
                      <vs-th>Action</vs-th>
                    </template>

                    <template slot-scope="{ data }">
                      <tbody>
                        <vs-tr
                          :data="tr"
                          :key="indextr"
                          v-for="(tr, indextr) in data"
                        >
                          <vs-td>
                            <p class="font-medium truncate">
                              {{ indextr + 1 }}
                            </p>
                          </vs-td>

                          <vs-td>
                            <p>{{ tranformDate(tr.datestart) }}</p>
                          </vs-td>

                          <vs-td>
                            <p v-if="tr.datestop">
                              {{ tranformDate(tr.datestop) }}
                            </p>
                            <p v-else style="color: #3ca787">In progress</p>
                          </vs-td>

                          <vs-td>
                            <p v-if="tr.worked">
                              <span v-if="tr.worked.days && tr.worked.hours"
                                >{{
                                  padLeadingZeros(
                                    tr.worked.days * 24 + tr.worked.hours,
                                    2
                                  )
                                }}:</span
                              >
                              <span v-else-if="tr.worked.hours"
                                >{{
                                  padLeadingZeros(tr.worked.hours, 2)
                                }}:</span
                              >
                              <span v-else>00:</span>
                              <span v-if="tr.worked.minutes"
                                >{{
                                  padLeadingZeros(tr.worked.minutes, 2)
                                }}:</span
                              >
                              <span v-else>00:</span>
                              <span v-if="tr.worked.seconds">{{
                                padLeadingZeros(tr.worked.seconds, 2)
                              }}</span>
                              <span v-else>00</span>
                            </p>
                            <p v-else>N/A</p>
                          </vs-td>
                          <vs-td>
                            <p>{{ tr.comment }}</p>
                          </vs-td>
                          <vs-td>
                            <a v-if="tr.photosrcin" @click="displayImage(tr.photosrcin)">View</a>
                          </vs-td>
                          <vs-td>
                            <a v-if="tr.photosrcout" @click="displayImage(tr.photosrcout)">View</a>
                          </vs-td>

                          <vs-td class="whitespace-no-wrap">
                            <feather-icon
                              v-if="tr.datestop"
                              icon="EditIcon"
                              svgClasses="w-5 h-5 hover:text-primary stroke-current"
                              @click.stop="editData(tr)"
                            />
                          </vs-td>
                        </vs-tr>
                      </tbody>
                    </template>
                  </vs-table>
                  <br />
                </div>
              </template>
            </div>
          </template>
        </div>
      </div>
    </vx-card>
    <vs-prompt
      :active.sync="activePrompt1"
      @cancel="closePrompt1"
      @accept="closePrompt1"
      @close="closePrompt1"
    >
      <div
        id="image1"
        style="
          width:370px;
        "
      >
        <img width="370px" v-bind:src="photosrc" />
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import DataViewSidebar from "./DataViewSidebar.vue";
import vSelect from "vue-select";
import axios from "@/axios.js";
import Datepicker from "vuejs-datepicker";
import moduleEmployeeList from "@/store/employee/moduleDataList.js";
import moment from "moment";
import momentbusiness from "moment-business-days";

export default {
  components: {
    DataViewSidebar,
    vSelect,
    Datepicker,
  },
  data() {
    return {
      displayExport: false,
      selected: [],
      //itemsPerPage: 1000,
      isMounted: false,
      // Data Sidebar
      addNewDataSidebar: false,
      sidebarData: {},
      buttonSubmitOpen: false,
      state: {},
      personId: null,
      basic_data: [],
      attendance_data: [],
      summarypermonth0: [],
      summarypermonth1: [],
      summarypermonth2: [],
      activePrompt1: false,
      photosrc: null,
    };
  },
  computed: {
    attendances() {
      return this.$store.state.dataListEmployee.attendances;
    },
    validateForm() {
      return !this.errors.any();
    },
    currentPage() {
      if (this.isMounted) {
        if (this.attendance_data.id) return this.$refs.table.currentx;
      }
      return 0;
    },
    queriedItems() {
      if (this.attendance_data.id)
        return this.$refs.table
          ? this.$refs.table.queriedResults.length
          : this.users.length;
    },
  },
  methods: {
    ViewPerson(id) {
      window.location.replace("/web/person/" + id);
    },
    closePrompt1()
    {},
    displayImage(Photo) {
      this.photosrc = Photo;
      this.activePrompt1 = true;
    },
    getMonth(monthnb) {
      if (monthnb == 0) return moment().format("MMMM YYYY");
      else if (monthnb == -1) return moment().add(-1, "M").format("MMMM YYYY");
      else if (monthnb == -2) return moment().add(-2, "M").format("MMMM YYYY");
    },
    jourferier(year, month) {
      let jourf = 0;
      if (month == 1) {
        let date1 = moment(year + "-" + month + "-01");
        let date2 = moment(year + "-" + month + "-02");
        let date3 = moment(year + "-" + month + "-24");
        if (momentbusiness(date1).isBusinessDay()) jourf++;
        if (momentbusiness(date2).isBusinessDay()) jourf++;
        if (momentbusiness(date3).isBusinessDay()) jourf++;
        return jourf;
      } else if (month == 4) {
        let date1 = moment(year + "-" + month + "-24");
        let date2 = moment(year + "-" + month + "-25");
        if (momentbusiness(date1).isBusinessDay()) jourf++;
        if (momentbusiness(date2).isBusinessDay()) jourf++;
        return jourf;
      } else if (month == 5) {
        let date1 = moment(year + "-" + month + "-01");
        if (momentbusiness(date1).isBusinessDay()) jourf++;
        return jourf;
      } else if (month == 6) {
        let date1 = moment(year + "-" + month + "-01");
        if (momentbusiness(date1).isBusinessDay()) jourf++;
        return jourf;
      } else if (month == 8) {
        let date1 = moment(year + "-" + month + "-15");
        if (momentbusiness(date1).isBusinessDay()) jourf++;
        return jourf;
      } else if (month == 11) {
        let date1 = moment(year + "-" + month + "-30");
        if (momentbusiness(date1).isBusinessDay()) jourf++;
        return jourf;
      } else if (month == 12) {
        let date1 = moment(year + "-" + month + "-01");
        let date2 = moment(year + "-" + month + "-25");
        let date3 = moment(year + "-" + month + "-26");
        if (momentbusiness(date1).isBusinessDay()) jourf++;
        if (momentbusiness(date2).isBusinessDay()) jourf++;
        if (momentbusiness(date3).isBusinessDay()) jourf++;
        return jourf;
      } else return 0;
    },
    workday_count(monthnb) {
      let start = null;
      if (monthnb == 0) {
        start = moment().format("YYYY-MM-DD");
        return (
          momentbusiness(start).monthBusinessDays().length -
          this.jourferier(
            moment(start).format("YYYY"),
            moment(start).format("MM")
          )
        );
      } else if (monthnb == -1) {
        start = moment().add(-1, "M").format("YYYY-MM-DD");
        return (
          momentbusiness(start).monthBusinessDays().length -
          this.jourferier(
            moment(start).format("YYYY"),
            moment(start).format("MM")
          )
        );
      } else if (monthnb == -2) {
        start = moment().add(-2, "M").format("YYYY-MM-DD");
        return (
          momentbusiness(start).monthBusinessDays().length -
          this.jourferier(
            moment(start).format("YYYY"),
            moment(start).format("MM")
          )
        );
      }
      return "N/A";
    },
    padLeadingZeros(num, size) {
      var s = num + "";
      while (s.length < size) s = "0" + s;
      return s;
    },
    addNewData() {
      if (this.attendances.length > 0 && this.attendances[0].datestop == null) {
        this.$vs.notify({
          color: "danger",
          title: "Action Impossible!",
          text: "An attendance is in progress!",
        });
      } else {
        if (!this.attendance_data.id) {
          let idperson = this.$route.params.idperson;
          this.sidebarData = { idperson };
          this.toggleDataSidebar(true);
        }
      }
    },
    editData(data) {
      if (data.id) {
        this.sidebarData = {
          id: data.id,
          datestart: data.datestart,
          datestop: data.datestop,
          idperson: this.$route.params.idperson,
          comment: data.comment,
        };
        this.toggleDataSidebar(true);
      }
    },
    getActiveColors(status) {
      if (status === "true") return "primary";
      if (status === false) return "danger";
      return "warning";
    },
    toggleDataSidebar(val = false) {
      this.addNewDataSidebar = val;
    },
    tranformDate(dt) {
      const format1 = "YYYY-MM-DD HH:mm:ss";
      return moment(dt).format(format1);
    },
    fetchDataAttendanceBasicListItems(idperson) {
      if (idperson) {
        this.$store
          .dispatch(
            "dataListEmployee/fetchDataAttendanceBasicListItems",
            idperson
          )
          .then((res) => {
            this.basic_data = res.data;
          })
          .catch((err) => {
            if (err.response.status === 404) {
              this.user_not_found = true;
              return;
            }
            console.error(err);
          });
      } else {
        this.basic_data = {};
      }
    },
    fetchDataAttendanceListItems(idperson) {
      if (idperson) {
        this.$store.dispatch(
          "dataListEmployee/fetchDataAttendanceListItems",
          idperson
        );
      } else {
        this.attendance_data = {};
      }
    },
    fetchsummarypermonth0(idperson, month) {
      if (idperson) {
        this.$store.dispatch(
          "dataListEmployee/fetchsummarypermonth0",
          idperson
        );
      } else {
        this.summarypermonth0 = {};
      }
    },
    fetchsummarypermonth1(idperson, month) {
      if (idperson) {
        this.$store.dispatch(
          "dataListEmployee/fetchsummarypermonth1",
          idperson
        );
      } else {
        this.summarypermonth1 = {};
      }
    },
    fetchsummarypermonth2(idperson, month) {
      if (idperson) {
        this.$store.dispatch(
          "dataListEmployee/fetchsummarypermonth2",
          idperson
        );
      } else {
        this.summarypermonth2 = {};
      }
    },
  },

  created() {
    if (localStorage.getItem("login-roles").toLowerCase().includes("user")) {
      this.$vs.notify({
        title: "Denied",
        text: "Access to the this page is reserved for administrators",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "danger",
        position: "bottom-right",
        time: 8000,
      });
      this.$router.push({ path: "/dashboard/analytics" });
    } 
    if (!moduleEmployeeList.isRegistered) {
      this.$store.registerModule("dataListEmployee", moduleEmployeeList);
      moduleEmployeeList.isRegistered = true;
    }
    this.fetchDataAttendanceBasicListItems(this.$route.params.idperson);
    this.fetchDataAttendanceListItems(this.$route.params.idperson);
    this.fetchsummarypermonth0(this.$route.params.idperson);
    this.fetchsummarypermonth1(this.$route.params.idperson);
    this.fetchsummarypermonth2(this.$route.params.idperson);
  },
  mounted() {
    this.isMounted = true;
  },
};
</script>

